import { BrowserRouter, Route, Routes } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import './App.scss'
import AuthorizedRoute from 'components/AuthorizedRoute';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import ProfileSelectionPage from 'pages/ProfileSelectionPage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      networkMode: "always"
    },
    mutations: {
      networkMode: 'always'
    }
  }
})

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename='/dashboard'>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          {/* @ts-ignore */}
          <Route path="*" element={<AuthorizedRoute requiredPrevileges={[]}>
            <Routes>
              <Route path="/profiles" element={<ProfileSelectionPage />} />
              <Route index path="*" element={<DashboardPage />} />
            </Routes>
          </AuthorizedRoute>} />
        </Routes>
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
